module.exports = MaterialUI.ExpansionPanelDetails;